module.exports = __webpack_public_path__ + "img/photo-default.8b0d4d59.svg";